import { Select } from '@opten/gin-tonic/components/select';

export class Filter {
	constructor(private element: HTMLSelectElement) {
		const options = {
			componentClassName: 'c-filter',
			componentValueClassName: 'c-filter__value',
			componentArrowClassName: 'c-filter__arrow',
			panelClassName: 'c-filter__panel',
			optionClassName: 'c-filter__option',
		};
		new Select(this.element, options);
	}

	public getSelectedOption() {
		return this.element.selectedOptions[0].value;
	}
}
